import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { usersService } from "../../services/UsersService";
import { formatDateTime } from "../../config/Config";
import { Button } from "primereact/button";

        

export const UserGroups = ({ userID }) => {
	const [loading, setLoading] = useState(false);
	const [data, setData] = useState([]);

	useEffect(() => {
		setLoading(true);
		usersService
			.getGroupsAudit(userID)
			.then((data) => {
				setData(data);
				setLoading(false);
			})
			.catch((error) => {
				setLoading(false);
				console.error("Error fetching groups:", error);
			});
	}, [userID]);

	return (
		<>
			<DataTable size="small" value={data} paginator rows={10} rowsPerPageOptions={[5, 10, 25]} loading={loading}>
				<Column field="groupName" header="Group Name" />
				<Column field="createdBy" header="Created By" />
				<Column field="createdDate" header="Created Date" body={(e) => formatDateTime(e.createdDate)} />
				<Column field="updatedBy" header="Updated By" />
				<Column field="updatedDate" header="Updated Date" body={(e) => e?.updatedDate?formatDateTime(e.updatedDate):""} />
				
				<Column
					field="active"
					header="Status"
					body={(e) =>
						e?.active === true ? (
							<Button
								label="Active"
								style={{ textAlign: "center", height: "30px" }}
								className="p-button-success p-button-rounded"
							/>
						) : (
							<Button
								label="Not Active"
								style={{ 
									textAlign: "center", 
									height: "30px", 
									textAlign: "center"
								}}
								className="p-button-danger p-button-rounded"
							/>
						)
					}
					sortable
				/>
			</DataTable>
		</>
	);
};
